import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { useSlotGroup } from '@vibesites/runtime/react';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

const RUNTIME_DEF: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: { label: 'Image', type: 'image', defaultField: 'property_featured_image' },
    alt: { label: 'Alt Text', type: 'text', defaultValue: 'Apply now banner' },
  },
};

export function ApplyNowHero() {
  const bgImage = useSlotGroup('applynowhero.bg_image', RUNTIME_DEF);

  return (
    <section className="relative h-[42vh] min-h-[300px] max-h-[420px] overflow-hidden">
      <EditableSlotGroup groupPath="applynowhero.bg_image" definition={RUNTIME_DEF} className="absolute inset-0">
        {bgImage.image ? (
          <VibesitesImage url={bgImage.image} alt={bgImage.alt || 'Apply now banner'} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-[var(--vibe-color-text)]" />
        )}
        <div className="absolute inset-0 bg-black/30" />
      </EditableSlotGroup>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4" style={{ paddingTop: 'calc(var(--offer-banner-height, 0px) + 72px)' }}>
        <RichTextContent path="applynowhero.title" as="h1" className="font-heading text-3xl sm:text-4xl md:text-5xl font-normal mb-3 uppercase tracking-wider" />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ApplyNowHero',
  displayName: 'Apply Now Hero',
  tokens: {
    'applynowhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Apply Now</p>',
    },
  },
  slotGroups: {
    'applynowhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: { label: 'Image', type: 'image', defaultField: 'property_featured_image' },
        alt: { label: 'Alt Text', type: 'text', defaultValue: 'Apply now banner' },
      },
    },
  },
};

(ApplyNowHero as any).contentSchema = contentSchema;

export default ApplyNowHero;
